import { EffectCallback, useEffect } from "react";

export function useMountEffect(effect: EffectCallback) {
  return useEffect(effect, []);
}